module.exports = __webpack_public_path__ + "media/src/images/zu_05keep_rules01-7329493d40f0586964ee84e484abc57d.gif";